"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchColumns = function SearchColumns(_ref) {
  var columns = _ref.columns,
      query = _ref.query,
      onChange = _ref.onChange,
      classNames = _ref.classNames;

  var onQueryChange = function onQueryChange(event) {
    onChange(_objectSpread(_objectSpread({}, query), {}, _defineProperty({}, event.target.name, event.target.value)));
  };

  return /*#__PURE__*/_react["default"].createElement("tr", null, columns.map(function (column, i) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: "".concat(column.property || i, "-column-filter"),
      className: classNames.filter
    }, column && column.property && (!('filterable' in column) || column.filterable) ? /*#__PURE__*/_react["default"].createElement("input", {
      onChange: onQueryChange,
      className: classNames.filterInput,
      name: column.property,
      placeholder: column.filterPlaceholder || '',
      value: query[column.property] || ''
    }) : '');
  }));
};

SearchColumns.propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  classNames: _propTypes["default"].object,
  onChange: _propTypes["default"].func.isRequired,
  query: _propTypes["default"].object
};
SearchColumns.defaultProps = {
  query: {},
  classNames: {
    filter: 'column-filter',
    filterInput: 'column-filter-input'
  }
};
var _default = SearchColumns;
exports["default"] = _default;